import { keyframes as h } from "@emotion/css";
const g = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "polygon(0 0, 0 0, 0 0)",
  height: 1,
  margin: -1,
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: 1,
  whiteSpace: "nowrap"
}, s = (r, i = 1) => {
  const n = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, t = r.replace(n, (m, l, u, d) => l + l + u + u + d + d), o = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t), c = o ? {
    r: parseInt(o[1], 16),
    g: parseInt(o[2], 16),
    b: parseInt(o[3], 16)
  } : { r: 0, g: 0, b: 0 };
  return `rgba(${c.r}, ${c.g}, ${c.b}, ${i})`;
}, p = (r, i = "px") => {
  if (!r.length)
    return "0px";
  const n = (t) => Number(t) === 0 || Number(t);
  return r.map((t) => `${t}${n(t) ? i : ""}`).join(" ");
}, F = (r, i = "min-width") => {
  let n = r;
  return i === "max-width" && (n -= 1), `@media screen and (${i}: ${n}px)`;
};
h({
  "0%": { opacity: 0.6 },
  "50%": { opacity: 1 },
  "100%": { opacity: 0.6 }
});
h({
  from: {
    transform: "rotate(0deg)"
  },
  to: {
    transform: "rotate(360deg)"
  }
});
var e = {
  // Base colours
  white: "#FFF",
  black: "#000",
  jumbo: "#7C7C80",
  catskillWhite: "#EEF3F6",
  porcelain: "#F3F4F5",
  athensGray: "#F9FAFB",
  // THEMES
  // Primary
  cornflowerBlue: "#5EA5EE",
  havelockBlue: "#5698DC",
  hawkesBlue: "#E4F0FC",
  mariner: "#2E71C1",
  // Secondary
  amethyst: "#BA69C8",
  wisteria: "#A55AB2",
  whiteLilac: "#F8F0F9",
  affair: "#974CA3",
  // Success
  jungleGreen: "#34B96F",
  eucalyptus: "#2FA765",
  harp: "#E1F1E7",
  seaGreen: "#229053",
  // Warning
  sandyBrown: "#F28F5D",
  burntSienna: "#E88857",
  provincialPink: "#FDF3EE",
  redDamask: "#D77644",
  // Error
  mandy: "#e25c59",
  chestnutRose: "#D05552",
  linen: "#FCEEEE",
  mojo: "#C24441",
  // Legacy
  scooter: "#40aadb",
  pelorous: "#3A99C4",
  whiteIce: "#D9EEF8",
  jellyBean: "#257FA8",
  // Light
  mystic: "#E4EBEF",
  geyser: "#DAE0E4",
  grayChateau: "#A6ACAF",
  scorpion: "#5C5C5C",
  // Dark
  oxfordBlue: "#343951",
  blueZodiac: "#0B1236",
  mischka: "#D3D5DF",
  blackPearl: "#060A22",
  // Tertiary
  froly: "#F96E8D",
  cranberry: "#E55D7B",
  wispPink: "#FCE6EA",
  cabaret: "#D54F6D",
  // Info
  shakespeare: "#41BFCB",
  bostonBlue: "#30A4AF",
  iceberg: "#D8F2F4",
  easternBlue: "#238F99"
}, a = {
  secondary: {
    base: e.amethyst,
    medium: e.wisteria,
    light: e.whiteLilac,
    dark: e.affair
  },
  success: {
    base: e.jungleGreen,
    medium: e.eucalyptus,
    light: e.harp,
    dark: e.seaGreen
  },
  warning: {
    base: e.sandyBrown,
    medium: e.burntSienna,
    light: e.provincialPink,
    dark: e.redDamask
  },
  error: {
    base: e.mandy,
    medium: e.chestnutRose,
    light: e.linen,
    dark: e.mojo
  },
  legacy: {
    base: e.scooter,
    medium: e.pelorous,
    light: e.whiteIce,
    dark: e.jellyBean
  },
  light: {
    base: e.grayChateau,
    medium: e.geyser,
    light: e.mystic,
    dark: e.scorpion
  },
  dark: {
    base: e.oxfordBlue,
    medium: e.blueZodiac,
    light: e.mischka,
    dark: e.blackPearl
  },
  tertiary: {
    base: e.froly,
    medium: e.cranberry,
    light: e.wispPink,
    dark: e.cabaret
  },
  info: {
    base: e.shakespeare,
    medium: e.bostonBlue,
    light: e.iceberg,
    dark: e.easternBlue
  },
  primary: {
    base: e.cornflowerBlue,
    medium: e.havelockBlue,
    light: e.hawkesBlue,
    dark: e.mariner
  }
};
`${e.white}${s(e.white, 0)}${e.white}${s(e.white, 0)}${s(e.grayChateau, 0.15)}${s(e.grayChateau, 0)}${s(e.grayChateau, 0.15)}${s(e.grayChateau, 0)}`;
const b = (r = "primary") => {
  switch (r) {
    case "secondary":
      return a.secondary;
    case "success":
      return a.success;
    case "warning":
      return a.warning;
    case "error":
      return a.error;
    case "legacy":
      return a.legacy;
    case "light":
      return a.light;
    case "dark":
      return a.dark;
    case "tertiary":
      return a.tertiary;
    case "info":
      return a.info;
    default:
      return a.primary;
  }
};
export {
  F as b,
  b as k,
  s as o,
  g as p,
  p as y
};
